import "../styles/Work.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import sowjanya from "../assets/Sowjanya_studios.png";
import masters from "../assets/masterabroad.png";
import C2A from "../assets/ctoa.png";
import MayuInfra from "../assets/mayuinfra.png";

import ContactSection from "../components/ContactSection";
import WhatWeDeliver from "../components/WhatWeDeliver"
// Marketing Components
import MarketingOne from "../components/Marketing";
import MarketingTwo from "../components/VideoProduction";
import MarketingThree from "../components/WhatWeDeliver";

const portfolioData = [
  {
    id: 1,
    title: "Sowjanya Studios",
    category: "Visual Branding",
    tag: "Branding",
    year: "2024",
    image: sowjanya,
  },
  {
    id: 2,
    title: "MastersAbroad",
    category: "Visual Branding",
    tag: "Branding",
    year: "2025",
    image: masters,
  },
  {
    id: 3,
    title: "Mayu Infra",
    category: "Visual Branding",
    tag: "Branding",
    year: "2025",
    image: MayuInfra,
  },
  {
    id: 4,
    title: "C2A",
    category: "Visual Branding",
    tag: "Branding",
    year: "2024",
    image: C2A,
  },
];

function Work() {
  const [active, setActive] = useState("Visual Branding");
  const navigate=useNavigate();

  return (
    <>
      <section className="portfolio">
        <div className="portfolio-header">
          <div className="portfolio-label">
            <span></span>
            <p>Portfolio</p>
          </div>

          <h2>
            Our Work<span>.</span>
          </h2>

          <p className="portfolio-subtitle">
            A selection of projects where strategy met craft —
            identities built to perform, not just to look pretty.
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="portfolio-filter">
          <button
            className={active === "Visual Branding" ? "active" : ""}
            onClick={() => setActive("Visual Branding")}
          >
            Branding
          </button>

          <button
            className={active === "Digital Marketing" ? "active" : ""}
            onClick={() => setActive("Digital Marketing")}
          >
            Digital Marketing
          </button>
        </div>

        {/* Conditional Rendering */}
        {active === "Visual Branding" ? (
          <div className="portfolio-grid">
            {portfolioData.map((item) => (
              <div className="portfolio-card" key={item.id}>
                <div className="image-box">
                  <img src={item.image} alt={item.title} />

                  <span className="tag">{item.tag}</span>

                  <span className="year">{item.year}</span>

                  <div className="overlay">
                    <h3>{item.title}</h3>
                  </div>
                </div>

                <div className="card-footer">
                  <p>Brand Identity, Outdoor Marketing</p>

                  <a href="/" onClick={()=>{navigate("/brandingcasestudy")}}>View Case Study</a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="marketing-sections">
            <MarketingOne />
            {/* <MarketingTwo /> */}
            {/* <MarketingThree /> */}
          </div>
        )}
      </section>

      <WhatWeDeliver />

      <ContactSection />
    </>
  );
}

export default Work;